import { ReactNode } from 'react';
import { Stack } from '@mui/system';
import { Typography } from '@mui/material';

export const CurrencyDisplay = ({
  label,
  children,
  size,
  notCurrency = true,
}: // hasChanged,
{
  label: ReactNode;
  children: number | undefined | null | string;
  size?: 'large' | 'normal';
  hasChanged?: boolean;
  notCurrency?: boolean;
}) => {
  return (
    <Stack>
      <Typography fontSize={'small'}>{label}</Typography>
      <Typography
        fontWeight={'bold'}
        fontSize={size === 'large' ? 22 : undefined}
        color={
          children === undefined || children === null ? 'lightGrey' : 'black'
        }
      >
        {children === undefined || children === null ? (
          <>N/A</>
        ) : (
          <>
            {notCurrency
              ? `$ ${children.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })}`
              : children}
          </>
        )}
      </Typography>
    </Stack>
  );
};
